import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { getEstudo } from "@/lib/estudo";
import { Target, Loader2, TrendingUp, ArrowRight } from "lucide-react";

export default function PlanoPage() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const est = getEstudo();
    api.get("/study/adaptive", { params: { banca: est.banca, concurso: est.concurso } })
      .then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const recs = data?.recomendacoes || [];

  return (
    <div data-testid="plano-page" className="mx-auto max-w-3xl space-y-5 px-4 py-6 sm:px-6 sm:py-8">
      <div className="flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-xl bg-indigo-500/15 text-indigo-400"><Target className="h-5 w-5" /></span>
        <div>
          <h1 className="text-2xl font-extrabold text-white">Plano de Estudos Adaptativo</h1>
          <p className="text-sm text-slate-400">Prioriza alta cobrança no banco + seu menor desempenho real.</p>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-emerald-400" /></div>
      ) : recs.length === 0 ? (
        <div className="rounded-2xl border border-slate-800 bg-slate-900 p-10 text-center text-slate-400" data-testid="plano-empty">
          {data?.message || "Ainda não há dados suficientes. Responda questões para receber um plano adaptativo."}
        </div>
      ) : (
        <>
          {data?.base && <p className="text-xs text-slate-500">{data.base}</p>}
          <div className="space-y-3">
            {recs.map((r, i) => (
              <div key={r.disciplina} data-testid="plano-rec" className="rounded-2xl border border-slate-800 bg-slate-900 p-5">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="grid h-8 w-8 place-items-center rounded-lg bg-indigo-500/15 text-sm font-bold text-indigo-300">{i + 1}</span>
                    <div>
                      <p className="font-bold text-white">{r.disciplina}
                        {r.confianca && (
                          <span data-testid="plano-confianca" className={`ml-2 rounded-full px-2 py-0.5 text-[10px] font-bold ${
                            r.confianca === "alta" ? "bg-emerald-500/15 text-emerald-300"
                            : r.confianca === "média" ? "bg-amber-500/15 text-amber-300"
                            : "bg-slate-700 text-slate-400"}`}>
                            confiança {r.confianca}
                          </span>
                        )}
                      </p>
                      <p className="text-xs text-slate-500">{r.acertos}/{r.total} corretas · {r.questoes_no_banco} questões no banco{!r.amostra_suficiente ? " · amostra pequena" : ""}</p>
                    </div>
                  </div>
                  <span className={`font-mono-stats text-lg font-bold ${r.aproveitamento >= 70 ? "text-emerald-400" : r.aproveitamento >= 40 ? "text-amber-400" : "text-red-400"}`}>
                    {r.aproveitamento}%
                  </span>
                </div>
                <div className="mt-3 h-2 overflow-hidden rounded-full bg-slate-800">
                  <div className={`h-full rounded-full ${r.aproveitamento >= 70 ? "bg-emerald-500" : r.aproveitamento >= 40 ? "bg-amber-500" : "bg-red-500"}`}
                    style={{ width: `${Math.min(100, r.aproveitamento)}%` }} />
                </div>
                <button onClick={() => navigate("/questoes")} data-testid="plano-praticar"
                  className="mt-3 flex items-center gap-1.5 rounded-lg bg-emerald-500 px-3 py-1.5 text-xs font-bold text-white hover:bg-emerald-600">
                  <TrendingUp className="h-3.5 w-3.5" /> Praticar {r.disciplina} <ArrowRight className="h-3.5 w-3.5" />
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
